import React, { Component } from 'react';

class CostoEmision extends Component {
    constructor( props ) {
        super( props );
        this.state = {                
            CostoEmision:this.props.solicitudCuenta.productoVisaSeleccionado.CostoEmision,
            
            porcEmision:"",
            porcenBonificacionDesde:"",
            porcenBonificacionHasta:"",
            siNoPorcEmision:false,
            siNoPorcEmisionDF:false,

            cuotasEmision:"",
            cuotasDesde:"",
            cuotasHasta:"",

            };

    }
    componentDidMount(){
        const {ProductoVisaSeleccionadoDatosDefault, productoVisaSeleccionado}=this.props.solicitudCuenta;

        let productoDefault=ProductoVisaSeleccionadoDatosDefault; 

        let producto = productoVisaSeleccionado;

        if(producto.CostoEmision !="SC"){
            if(producto.CargoEnCuotas){
                //SI EL PRODUCTO PERMITE EL CARGO EN CUOTAS

                this.setState({cuotasDesde: producto.CargoEnCuotasDesde, cuotasHasta: producto.CargoEnCuotasHasta});
                //SI EL ID DE ADICIONAL NO ES 0 SE ESTÁ EDITANDO UN ADICIONAL EXISTENTE
                if(this.props.data.idAdicional !=0){
                    this.setState({cuotasEmision: this.props.data.cuotasEmision });
                }
                //SI HAY SELECCION DEL TITULAR LA OPCIÓN POR DEFAULT SERÁ ESA
                else if(this.props.solicitudCuenta.cuotasEmision && this.props.data.idAdicional ==0){
                    this.setState({cuotasEmision: this.props.solicitudCuenta.cuotasEmision });
                    this.props.changeInput("cuotasEmision", this.props.solicitudCuenta.cuotasEmision);

                //SI NO, DE HABERLA, LA OPCIÓN POR DEFAULT SERÁ LA DEL PRODUCTO
                }else if(productoDefault.CuotasDefault && this.props.data.idAdicional ==0){
                    this.setState({cuotasEmision: productoDefault.CuotasDefault });
                    this.props.changeInput("cuotasEmision", productoDefault.CuotasDefault);
                }
            }

            if(producto.CostoEmision =="BP"){ 
                //SI EL COSTO DE EMISIÓN DETERMINADO POR EL PRODUCTO ES "BONIFICADO PARCIALMENTE"

                this.setState({ porcenBonificacionDesde: producto.PorcBonificacionEmisionDesde, porcenBonificacionHasta: producto.PorcBonificacionEmisionHasta }); //SETEO MINIMO Y MÁXIMO DE PORCENTAJE DE BONIFICACIÓN
    
                    let porcEmisionDefault = productoDefault.BonificacionEmisionDefault;
                    let porcEmisionTitularCuenta = this.props.solicitudCuenta.porcEmision;

                    if(this.props.data.idAdicional != 0){
                        this.setState({porcEmision: this.props.data.porcEmision});
                    }
                    //SI HAY SELECCION DEL TITULAR LA OPCIÓN POR DEFAULT SERÁ ESA
                    else if(porcEmisionTitularCuenta && this.props.data.idAdicional == 0){ 
                        this.setState({porcEmision: porcEmisionTitularCuenta});
                        this.props.changeInput("porcEmision", porcEmisionTitularCuenta);

                    //SI NO, DE HABERLA, LA OPCIÓN POR DEFAULT SERÁ LA DEL PRODUCTO
                    }else if(porcEmisionDefault && this.props.data.idAdicional == 0){ 
                        this.setState({porcEmision: porcEmisionDefault});
                        this.props.changeInput("porcEmision", porcEmisionDefault);
                    }
                    
                }
            }
            
    }

    /****************** UNA VEZ OBTENIDO EL CLIENTE TESTEAR SI ES NECESARIA LA ACTUALIZACIÓN DEL STATE CON componentWillReceiveProps ******************/

    /*componentWillReceiveProps(nextprops){
        let {productoVisaSeleccionado}=this.props.solicitudCuenta;
        let producto = productoVisaSeleccionado;
        if((nextprops.data.idAdicional!==this.props.data.idAdicional)||
        nextprops.data.cuentasAdicionales.length !== this.props.data.cuentasAdicionales.length ){
            if(this.state.CostoEmision=="BP"){
                this.setState({ porcEmision:nextprops.data.porcEmision}),
                this.props.changeInput("porcEmision",nextprops.data.porcEmision)  
            } 
            if(this.state.CostoEmision!=="SC"&& producto.CargoEnCuotas){
                    this.setState({cuotasEmision:nextprops.data.CuotasEmision}),
                    this.props.changeInput("cuotasEmision",nextprops.data.CuotasEmision)             
            }
        }
    } */   
    
        
    onEmisionInputBlur(e){
        const { value, dataset } = e.target;
        this.props.changeInput(dataset.code, value)
    }

    onEmisionInputChange(event) {
        const { value, dataset } = event.target;
        const regExp = new RegExp(dataset.validation);

        if (regExp.test(value) || value.replace(/\s/g, "", "") == "") {
            let newState = {
                [dataset.code]: value
            }
            if (dataset.code == "porcEmision") {
                newState = {
                    ...newState,
                    porcBonificacion: value
                }
            }
            if (dataset.code == "cuotasEmision") {
                newState = {
                    ...newState,
                    cuotasEmision: value
                }
            }
            this.setState(newState);
        }  
    }
   
    render() {
        const{data}=this.props;
       
        let errorRangoCostoEmision = false;
        let errorRangoCuotas = false;
        
        if(this.state.porcEmision && (parseInt(this.state.porcEmision) < parseInt(this.state.porcenBonificacionDesde) || parseInt(this.state.porcEmision) > parseInt(this.state.porcenBonificacionHasta))) errorRangoCostoEmision = true;
        if(this.state.cuotasEmision && (parseInt(this.state.cuotasEmision) < parseInt(this.state.cuotasDesde) || parseInt(this.state.cuotasEmision) > parseInt(this.state.cuotasHasta))) errorRangoCuotas = true;

        return (
            <div className="row top-separator-xs">
                <div className="col-xs-12">
                    <label className="label-primary">Costo Emisión</label>
                    
                   { this.state.CostoEmision =="BP" && <div className="row">
                        <div className="col-xs-2">
                            <label className="label-secondary">Bonificación Parcial</label>
                        </div>
                        <div className="col-xs-1">
                            <input 
                            className="form-control input-Short" 
                            type="text"
                            maxLength={3}
                            value={this.state.porcEmision}
                            data-code="porcEmision"
                            data-validation="^([1-9]?\d|100)$"
                            onChange={this.onEmisionInputChange.bind(this)}
                            onBlur={this.onEmisionInputBlur.bind(this)}
                            />
                        </div>
                        <div className="col-xs-2">
                            <label className="label-secondary">
                                {"% (entre "+ this.state.porcenBonificacionDesde +"% a "+this.state.porcenBonificacionHasta+"%)"}
                            </label>
                        </div>
                        <div className="col-md-12">
                            {(data.ERROR_ADICIONAL["seleccionoCostoEmision"] == false && errorRangoCostoEmision)
                                && <label className="error">{"El Costo Emisión debe estar dentro del rango definido por el producto."}</label>
                            }
                            {data.ERROR_ADICIONAL.seleccionoCostoEmision == false && !errorRangoCostoEmision &&
                                            <label className="error">{"Debe ingresar un Porcentaje."}</label>}
                        </div>
                    </div>}
                    { this.state.CostoEmision !="BP" && <div className="row">
                            {this.state.CostoEmision =="BT" &&
                                <div className="col-xs-2">
                                    <label className="label-secondary">Bonificado al 100%</label>
                                </div>
                            }
                            {this.state.CostoEmision =="SB" &&
                                <div className="col-xs-2">
                                    <label className="label-secondary">Sin Bonificar</label>
                                </div>
                            }
                            {this.state.CostoEmision =="SC" &&
                                <div className="col-xs-2">
                                    <label className="label-secondary">Sin Cargo</label>
                                </div>
                            }
                    </div>}

                    <div className="row top-separator-xs"></div>
                   
                     {
                         this.state.cuotasDesde !="" &&
                    <div className="row">
                        <div className="col-xs-2">
                            <label className="label-secondary">Cantidad de Cuotas</label>
                        </div>
                        <div className="col-xs-1">
                        <input
                            className="form-control input-Short"
                            type="text"
                            maxLength={3}
                            value={this.state.cuotasEmision}
                            data-code="cuotasEmision"
                            data-validation="^([1-9]?\d|100)$"
                            onChange={this.onEmisionInputChange.bind(this)}
                            onBlur={this.onEmisionInputBlur.bind(this)}                           
                            />
                        </div>
                        <div className="col-xs-2">
                            <label className="label-secondary">
                            {"(entre "+ this.state.cuotasDesde +" y "+ this.state.cuotasHasta+" cuotas)"}
                             </label> 
                        </div>
                        <div className="col-md-12">
                            {(data.ERROR_ADICIONAL["seleccionoCuotasEmision"] == false && errorRangoCuotas)
                                && <label className="error">{"La Cantidad de Cuotas debe estar dentro del rango definido por el producto."}</label>
                            }
                            {data.ERROR_ADICIONAL.seleccionoCuotasEmision == false && !errorRangoCuotas &&
                                            <label className="error">{"Ingrese Cantidad de cuotas."}</label>}
                        </div>
                    </div>} 

                </div>

            </div>

        );
    }
};

export default CostoEmision;